import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';

import { TransectionApiServices } from '../api/transection-api.service';

const { rejectPayment } = TransectionApiServices();

export const useRejectPayment = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return rejectPayment(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data: any) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 0) {
                    message.error(ResponseMessage)
                } else {
                    message.success(ResponseMessage);
                }

            },
        },
    );
};